export const emailPattern = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
export const phoneNumberPattern = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/
export const mobileNumberPattern = /^[0-9]{10}$/

export const validateEmail = val => {
  return emailPattern.test(val)
}
